import canUse from './canUse'
import Cookie from 'js-cookie'

const SetToken = (token) => {
    if (canUse()) {
        Cookie.set('mss_token', token, { expires: 365 })
    }
}

export default SetToken
